import { useTranslation } from "react-i18next"
import { cn } from "@/lib/utils"
import { Loader2Icon } from "lucide-react"

// Deviates from the shadcn original, whose aria-label is the literal "Loading".
// A spinner is often the only thing on screen, so it is the one word a screen
// reader has to get right in the reader's own language.
function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  const { t } = useTranslation()

  return (
    <Loader2Icon
      data-slot="spinner"
      role="status"
      aria-label={t("common.loading")}
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  )
}

export { Spinner }
